/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AiTokenUsage,
  ChangeBillingSubscription200Response,
  ChangeBillingSubscriptionRequest,
  CreateAiTokenUsageRequest,
  CreateBillingCheckoutSession200Response,
  CreateBillingCheckoutSessionRequest,
  CreateBillingPortalSession200Response,
  CreateBillingPortalSessionRequest,
  CreateSubscriptionRequest,
  CreditCharge,
  CreditEstimate,
  EstimateBillingFromPageCounts200Response,
  EstimateBillingFromPageCountsRequest,
  EstimateDocumentRequest,
  EstimateSupplementCost200Response,
  EstimateSupplementCostRequest,
  GetBillingCreditUsagePeriod200Response,
  GetBillingStripeCreditBalance200Response,
  GetBillingStripeSubscriptionStatusFromStripe200Response,
  GetTotalAiTokenUsageResponse,
  HandleStripeWebhook200Response,
  Problem,
  Subscription,
  SubscriptionDetailed,
  Tier,
  UpdateSubscriptionRequest,
} from '../models/index';
import {
    AiTokenUsageFromJSON,
    AiTokenUsageToJSON,
    ChangeBillingSubscription200ResponseFromJSON,
    ChangeBillingSubscription200ResponseToJSON,
    ChangeBillingSubscriptionRequestFromJSON,
    ChangeBillingSubscriptionRequestToJSON,
    CreateAiTokenUsageRequestFromJSON,
    CreateAiTokenUsageRequestToJSON,
    CreateBillingCheckoutSession200ResponseFromJSON,
    CreateBillingCheckoutSession200ResponseToJSON,
    CreateBillingCheckoutSessionRequestFromJSON,
    CreateBillingCheckoutSessionRequestToJSON,
    CreateBillingPortalSession200ResponseFromJSON,
    CreateBillingPortalSession200ResponseToJSON,
    CreateBillingPortalSessionRequestFromJSON,
    CreateBillingPortalSessionRequestToJSON,
    CreateSubscriptionRequestFromJSON,
    CreateSubscriptionRequestToJSON,
    CreditChargeFromJSON,
    CreditChargeToJSON,
    CreditEstimateFromJSON,
    CreditEstimateToJSON,
    EstimateBillingFromPageCounts200ResponseFromJSON,
    EstimateBillingFromPageCounts200ResponseToJSON,
    EstimateBillingFromPageCountsRequestFromJSON,
    EstimateBillingFromPageCountsRequestToJSON,
    EstimateDocumentRequestFromJSON,
    EstimateDocumentRequestToJSON,
    EstimateSupplementCost200ResponseFromJSON,
    EstimateSupplementCost200ResponseToJSON,
    EstimateSupplementCostRequestFromJSON,
    EstimateSupplementCostRequestToJSON,
    GetBillingCreditUsagePeriod200ResponseFromJSON,
    GetBillingCreditUsagePeriod200ResponseToJSON,
    GetBillingStripeCreditBalance200ResponseFromJSON,
    GetBillingStripeCreditBalance200ResponseToJSON,
    GetBillingStripeSubscriptionStatusFromStripe200ResponseFromJSON,
    GetBillingStripeSubscriptionStatusFromStripe200ResponseToJSON,
    GetTotalAiTokenUsageResponseFromJSON,
    GetTotalAiTokenUsageResponseToJSON,
    HandleStripeWebhook200ResponseFromJSON,
    HandleStripeWebhook200ResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    SubscriptionFromJSON,
    SubscriptionToJSON,
    SubscriptionDetailedFromJSON,
    SubscriptionDetailedToJSON,
    TierFromJSON,
    TierToJSON,
    UpdateSubscriptionRequestFromJSON,
    UpdateSubscriptionRequestToJSON,
} from '../models/index';

export interface CancelBillingSubscriptionRequest {
    subscriptionId: number;
}

export interface ChangeBillingSubscriptionOperationRequest {
    changeBillingSubscriptionRequest: ChangeBillingSubscriptionRequest;
}

export interface CreateAiTokenUsageOperationRequest {
    createAiTokenUsageRequest: CreateAiTokenUsageRequest;
}

export interface CreateBillingCheckoutSessionOperationRequest {
    createBillingCheckoutSessionRequest: CreateBillingCheckoutSessionRequest;
}

export interface CreateBillingPortalSessionOperationRequest {
    createBillingPortalSessionRequest: CreateBillingPortalSessionRequest;
}

export interface CreateBillingSubscriptionRequest {
    createSubscriptionRequest: CreateSubscriptionRequest;
}

export interface EstimateBillingDocumentCreditsRequest {
    estimateDocumentRequest: EstimateDocumentRequest;
}

export interface EstimateBillingFromPageCountsOperationRequest {
    estimateBillingFromPageCountsRequest: EstimateBillingFromPageCountsRequest;
}

export interface EstimateSupplementCostOperationRequest {
    estimateSupplementCostRequest: EstimateSupplementCostRequest;
}

export interface GetBillingChargesByCompanyRequest {
    companyId: number;
}

export interface GetBillingCreditUsagePeriodRequest {
    companyId: number;
}

export interface GetBillingEstimatesByCompanyRequest {
    companyId: number;
}

export interface GetBillingSubscriptionRequest {
    subscriptionId: number;
}

export interface GetBillingSubscriptionByCompanyRequest {
    companyId: number;
}

export interface GetBillingTierByCodeRequest {
    code: GetBillingTierByCodeCodeEnum;
}

export interface GetBillingTokenUsageByCompanyRequest {
    companyId: number;
}

export interface GetTotalBillingTokenUsageRequest {
    companyId: number;
}

export interface HandleStripeWebhookRequest {
    requestBody: { [key: string]: any; };
}

export interface UpdateBillingSubscriptionRequest {
    subscriptionId: number;
    updateSubscriptionRequest: UpdateSubscriptionRequest;
}

/**
 * BillingApi - interface
 * 
 * @export
 * @interface BillingApiInterface
 */
export interface BillingApiInterface {
    /**
     * 
     * @summary Cancel subscription
     * @param {number} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    cancelBillingSubscriptionRaw(requestParameters: CancelBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>>;

    /**
     * Cancel subscription
     */
    cancelBillingSubscription(requestParameters: CancelBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription>;

    /**
     * 
     * @summary Change existing subscription tier
     * @param {ChangeBillingSubscriptionRequest} changeBillingSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    changeBillingSubscriptionRaw(requestParameters: ChangeBillingSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeBillingSubscription200Response>>;

    /**
     * Change existing subscription tier
     */
    changeBillingSubscription(requestParameters: ChangeBillingSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeBillingSubscription200Response>;

    /**
     * 
     * @summary Record AI token usage
     * @param {CreateAiTokenUsageRequest} createAiTokenUsageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    createAiTokenUsageRaw(requestParameters: CreateAiTokenUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AiTokenUsage>>;

    /**
     * Record AI token usage
     */
    createAiTokenUsage(requestParameters: CreateAiTokenUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AiTokenUsage>;

    /**
     * 
     * @summary Create Stripe checkout session for new subscription
     * @param {CreateBillingCheckoutSessionRequest} createBillingCheckoutSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    createBillingCheckoutSessionRaw(requestParameters: CreateBillingCheckoutSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingCheckoutSession200Response>>;

    /**
     * Create Stripe checkout session for new subscription
     */
    createBillingCheckoutSession(requestParameters: CreateBillingCheckoutSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingCheckoutSession200Response>;

    /**
     * 
     * @summary Create Stripe billing portal session
     * @param {CreateBillingPortalSessionRequest} createBillingPortalSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    createBillingPortalSessionRaw(requestParameters: CreateBillingPortalSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingPortalSession200Response>>;

    /**
     * Create Stripe billing portal session
     */
    createBillingPortalSession(requestParameters: CreateBillingPortalSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingPortalSession200Response>;

    /**
     * 
     * @summary Create a new subscription
     * @param {CreateSubscriptionRequest} createSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    createBillingSubscriptionRaw(requestParameters: CreateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>>;

    /**
     * Create a new subscription
     */
    createBillingSubscription(requestParameters: CreateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription>;

    /**
     * 
     * @summary Estimate credit usage for a document
     * @param {EstimateDocumentRequest} estimateDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    estimateBillingDocumentCreditsRaw(requestParameters: EstimateBillingDocumentCreditsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreditEstimate>>;

    /**
     * Estimate credit usage for a document
     */
    estimateBillingDocumentCredits(requestParameters: EstimateBillingDocumentCreditsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreditEstimate>;

    /**
     * 
     * @summary Estimate token usage and cost from page counts (without uploading documents)
     * @param {EstimateBillingFromPageCountsRequest} estimateBillingFromPageCountsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    estimateBillingFromPageCountsRaw(requestParameters: EstimateBillingFromPageCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateBillingFromPageCounts200Response>>;

    /**
     * Estimate token usage and cost from page counts (without uploading documents)
     */
    estimateBillingFromPageCounts(requestParameters: EstimateBillingFromPageCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateBillingFromPageCounts200Response>;

    /**
     * 
     * @summary Estimate credit cost for supplement processing based on unmatched line items
     * @param {EstimateSupplementCostRequest} estimateSupplementCostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    estimateSupplementCostRaw(requestParameters: EstimateSupplementCostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateSupplementCost200Response>>;

    /**
     * Estimate credit cost for supplement processing based on unmatched line items
     */
    estimateSupplementCost(requestParameters: EstimateSupplementCostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateSupplementCost200Response>;

    /**
     * 
     * @summary Get credit charges by company ID
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingChargesByCompanyRaw(requestParameters: GetBillingChargesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreditCharge>>>;

    /**
     * Get credit charges by company ID
     */
    getBillingChargesByCompany(requestParameters: GetBillingChargesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreditCharge>>;

    /**
     * 
     * @summary Get credit usage for the current billing period
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingCreditUsagePeriodRaw(requestParameters: GetBillingCreditUsagePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingCreditUsagePeriod200Response>>;

    /**
     * Get credit usage for the current billing period
     */
    getBillingCreditUsagePeriod(requestParameters: GetBillingCreditUsagePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingCreditUsagePeriod200Response>;

    /**
     * 
     * @summary Get credit estimates by company ID
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingEstimatesByCompanyRaw(requestParameters: GetBillingEstimatesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreditEstimate>>>;

    /**
     * Get credit estimates by company ID
     */
    getBillingEstimatesByCompany(requestParameters: GetBillingEstimatesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreditEstimate>>;

    /**
     * Returns the customer\'s remaining credit balance from Stripe Billing Credits. This represents prepaid or promotional credits that offset usage charges. 
     * @summary Get remaining credit grant balance from Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingStripeCreditBalanceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingStripeCreditBalance200Response>>;

    /**
     * Returns the customer\'s remaining credit balance from Stripe Billing Credits. This represents prepaid or promotional credits that offset usage charges. 
     * Get remaining credit grant balance from Stripe
     */
    getBillingStripeCreditBalance(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingStripeCreditBalance200Response>;

    /**
     * Fetches subscription status from Stripe and syncs with local database. This endpoint is slow due to external API call. Frontend should cache and poll sparingly (max every 5 minutes). 
     * @summary Get current user\'s Stripe subscription status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingStripeSubscriptionStatusFromStripeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingStripeSubscriptionStatusFromStripe200Response>>;

    /**
     * Fetches subscription status from Stripe and syncs with local database. This endpoint is slow due to external API call. Frontend should cache and poll sparingly (max every 5 minutes). 
     * Get current user\'s Stripe subscription status
     */
    getBillingStripeSubscriptionStatusFromStripe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingStripeSubscriptionStatusFromStripe200Response>;

    /**
     * 
     * @summary Get subscription by ID
     * @param {number} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingSubscriptionRaw(requestParameters: GetBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionDetailed>>;

    /**
     * Get subscription by ID
     */
    getBillingSubscription(requestParameters: GetBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionDetailed>;

    /**
     * 
     * @summary Get subscription by company ID
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingSubscriptionByCompanyRaw(requestParameters: GetBillingSubscriptionByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionDetailed>>;

    /**
     * Get subscription by company ID
     */
    getBillingSubscriptionByCompany(requestParameters: GetBillingSubscriptionByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionDetailed>;

    /**
     * 
     * @summary Get tier by code
     * @param {'free' | 'starter' | 'pro' | 'expert'} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingTierByCodeRaw(requestParameters: GetBillingTierByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tier>>;

    /**
     * Get tier by code
     */
    getBillingTierByCode(requestParameters: GetBillingTierByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tier>;

    /**
     * 
     * @summary Get all subscription tiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingTiersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Tier>>>;

    /**
     * Get all subscription tiers
     */
    getBillingTiers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Tier>>;

    /**
     * 
     * @summary Get AI token usage records by company ID
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getBillingTokenUsageByCompanyRaw(requestParameters: GetBillingTokenUsageByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AiTokenUsage>>>;

    /**
     * Get AI token usage records by company ID
     */
    getBillingTokenUsageByCompany(requestParameters: GetBillingTokenUsageByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AiTokenUsage>>;

    /**
     * 
     * @summary Get total AI token usage for company
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    getTotalBillingTokenUsageRaw(requestParameters: GetTotalBillingTokenUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTotalAiTokenUsageResponse>>;

    /**
     * Get total AI token usage for company
     */
    getTotalBillingTokenUsage(requestParameters: GetTotalBillingTokenUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTotalAiTokenUsageResponse>;

    /**
     * Internal callback endpoint for Stripe events. The request body must be sent exactly as received by Stripe so the `stripe-signature` header can be verified. 
     * @summary Receive Stripe billing webhooks
     * @param {{ [key: string]: any; }} requestBody Stripe webhook JSON payload. Middleware must preserve the raw body bytes exactly as received so signature verification succeeds before any parsing or mutation. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    handleStripeWebhookRaw(requestParameters: HandleStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HandleStripeWebhook200Response>>;

    /**
     * Internal callback endpoint for Stripe events. The request body must be sent exactly as received by Stripe so the `stripe-signature` header can be verified. 
     * Receive Stripe billing webhooks
     */
    handleStripeWebhook(requestParameters: HandleStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HandleStripeWebhook200Response>;

    /**
     * 
     * @summary Update subscription
     * @param {number} subscriptionId 
     * @param {UpdateSubscriptionRequest} updateSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApiInterface
     */
    updateBillingSubscriptionRaw(requestParameters: UpdateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>>;

    /**
     * Update subscription
     */
    updateBillingSubscription(requestParameters: UpdateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription>;

}

/**
 * 
 */
export class BillingApi extends runtime.BaseAPI implements BillingApiInterface {

    /**
     * Cancel subscription
     */
    async cancelBillingSubscriptionRaw(requestParameters: CancelBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling cancelBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/subscriptions/{subscriptionId}`.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionFromJSON(jsonValue));
    }

    /**
     * Cancel subscription
     */
    async cancelBillingSubscription(requestParameters: CancelBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription> {
        const response = await this.cancelBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change existing subscription tier
     */
    async changeBillingSubscriptionRaw(requestParameters: ChangeBillingSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeBillingSubscription200Response>> {
        if (requestParameters['changeBillingSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'changeBillingSubscriptionRequest',
                'Required parameter "changeBillingSubscriptionRequest" was null or undefined when calling changeBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/stripe/change-subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeBillingSubscriptionRequestToJSON(requestParameters['changeBillingSubscriptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeBillingSubscription200ResponseFromJSON(jsonValue));
    }

    /**
     * Change existing subscription tier
     */
    async changeBillingSubscription(requestParameters: ChangeBillingSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeBillingSubscription200Response> {
        const response = await this.changeBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record AI token usage
     */
    async createAiTokenUsageRaw(requestParameters: CreateAiTokenUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AiTokenUsage>> {
        if (requestParameters['createAiTokenUsageRequest'] == null) {
            throw new runtime.RequiredError(
                'createAiTokenUsageRequest',
                'Required parameter "createAiTokenUsageRequest" was null or undefined when calling createAiTokenUsage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/token-usage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAiTokenUsageRequestToJSON(requestParameters['createAiTokenUsageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AiTokenUsageFromJSON(jsonValue));
    }

    /**
     * Record AI token usage
     */
    async createAiTokenUsage(requestParameters: CreateAiTokenUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AiTokenUsage> {
        const response = await this.createAiTokenUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Stripe checkout session for new subscription
     */
    async createBillingCheckoutSessionRaw(requestParameters: CreateBillingCheckoutSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingCheckoutSession200Response>> {
        if (requestParameters['createBillingCheckoutSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'createBillingCheckoutSessionRequest',
                'Required parameter "createBillingCheckoutSessionRequest" was null or undefined when calling createBillingCheckoutSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/stripe/create-checkout-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBillingCheckoutSessionRequestToJSON(requestParameters['createBillingCheckoutSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBillingCheckoutSession200ResponseFromJSON(jsonValue));
    }

    /**
     * Create Stripe checkout session for new subscription
     */
    async createBillingCheckoutSession(requestParameters: CreateBillingCheckoutSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingCheckoutSession200Response> {
        const response = await this.createBillingCheckoutSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Stripe billing portal session
     */
    async createBillingPortalSessionRaw(requestParameters: CreateBillingPortalSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingPortalSession200Response>> {
        if (requestParameters['createBillingPortalSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'createBillingPortalSessionRequest',
                'Required parameter "createBillingPortalSessionRequest" was null or undefined when calling createBillingPortalSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/stripe/create-portal-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBillingPortalSessionRequestToJSON(requestParameters['createBillingPortalSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBillingPortalSession200ResponseFromJSON(jsonValue));
    }

    /**
     * Create Stripe billing portal session
     */
    async createBillingPortalSession(requestParameters: CreateBillingPortalSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingPortalSession200Response> {
        const response = await this.createBillingPortalSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new subscription
     */
    async createBillingSubscriptionRaw(requestParameters: CreateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>> {
        if (requestParameters['createSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'createSubscriptionRequest',
                'Required parameter "createSubscriptionRequest" was null or undefined when calling createBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/subscriptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubscriptionRequestToJSON(requestParameters['createSubscriptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionFromJSON(jsonValue));
    }

    /**
     * Create a new subscription
     */
    async createBillingSubscription(requestParameters: CreateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription> {
        const response = await this.createBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Estimate credit usage for a document
     */
    async estimateBillingDocumentCreditsRaw(requestParameters: EstimateBillingDocumentCreditsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreditEstimate>> {
        if (requestParameters['estimateDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'estimateDocumentRequest',
                'Required parameter "estimateDocumentRequest" was null or undefined when calling estimateBillingDocumentCredits().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/estimates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EstimateDocumentRequestToJSON(requestParameters['estimateDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreditEstimateFromJSON(jsonValue));
    }

    /**
     * Estimate credit usage for a document
     */
    async estimateBillingDocumentCredits(requestParameters: EstimateBillingDocumentCreditsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreditEstimate> {
        const response = await this.estimateBillingDocumentCreditsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Estimate token usage and cost from page counts (without uploading documents)
     */
    async estimateBillingFromPageCountsRaw(requestParameters: EstimateBillingFromPageCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateBillingFromPageCounts200Response>> {
        if (requestParameters['estimateBillingFromPageCountsRequest'] == null) {
            throw new runtime.RequiredError(
                'estimateBillingFromPageCountsRequest',
                'Required parameter "estimateBillingFromPageCountsRequest" was null or undefined when calling estimateBillingFromPageCounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/estimates/from-page-counts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EstimateBillingFromPageCountsRequestToJSON(requestParameters['estimateBillingFromPageCountsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateBillingFromPageCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Estimate token usage and cost from page counts (without uploading documents)
     */
    async estimateBillingFromPageCounts(requestParameters: EstimateBillingFromPageCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateBillingFromPageCounts200Response> {
        const response = await this.estimateBillingFromPageCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Estimate credit cost for supplement processing based on unmatched line items
     */
    async estimateSupplementCostRaw(requestParameters: EstimateSupplementCostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateSupplementCost200Response>> {
        if (requestParameters['estimateSupplementCostRequest'] == null) {
            throw new runtime.RequiredError(
                'estimateSupplementCostRequest',
                'Required parameter "estimateSupplementCostRequest" was null or undefined when calling estimateSupplementCost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/estimates/supplement-cost`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EstimateSupplementCostRequestToJSON(requestParameters['estimateSupplementCostRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateSupplementCost200ResponseFromJSON(jsonValue));
    }

    /**
     * Estimate credit cost for supplement processing based on unmatched line items
     */
    async estimateSupplementCost(requestParameters: EstimateSupplementCostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateSupplementCost200Response> {
        const response = await this.estimateSupplementCostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get credit charges by company ID
     */
    async getBillingChargesByCompanyRaw(requestParameters: GetBillingChargesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreditCharge>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getBillingChargesByCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/charges/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreditChargeFromJSON));
    }

    /**
     * Get credit charges by company ID
     */
    async getBillingChargesByCompany(requestParameters: GetBillingChargesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreditCharge>> {
        const response = await this.getBillingChargesByCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get credit usage for the current billing period
     */
    async getBillingCreditUsagePeriodRaw(requestParameters: GetBillingCreditUsagePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingCreditUsagePeriod200Response>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getBillingCreditUsagePeriod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/credit-usage/company/{companyId}/period`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingCreditUsagePeriod200ResponseFromJSON(jsonValue));
    }

    /**
     * Get credit usage for the current billing period
     */
    async getBillingCreditUsagePeriod(requestParameters: GetBillingCreditUsagePeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingCreditUsagePeriod200Response> {
        const response = await this.getBillingCreditUsagePeriodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get credit estimates by company ID
     */
    async getBillingEstimatesByCompanyRaw(requestParameters: GetBillingEstimatesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreditEstimate>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getBillingEstimatesByCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/estimates/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreditEstimateFromJSON));
    }

    /**
     * Get credit estimates by company ID
     */
    async getBillingEstimatesByCompany(requestParameters: GetBillingEstimatesByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreditEstimate>> {
        const response = await this.getBillingEstimatesByCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the customer\'s remaining credit balance from Stripe Billing Credits. This represents prepaid or promotional credits that offset usage charges. 
     * Get remaining credit grant balance from Stripe
     */
    async getBillingStripeCreditBalanceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingStripeCreditBalance200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/stripe/credit-balance`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingStripeCreditBalance200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the customer\'s remaining credit balance from Stripe Billing Credits. This represents prepaid or promotional credits that offset usage charges. 
     * Get remaining credit grant balance from Stripe
     */
    async getBillingStripeCreditBalance(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingStripeCreditBalance200Response> {
        const response = await this.getBillingStripeCreditBalanceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches subscription status from Stripe and syncs with local database. This endpoint is slow due to external API call. Frontend should cache and poll sparingly (max every 5 minutes). 
     * Get current user\'s Stripe subscription status
     */
    async getBillingStripeSubscriptionStatusFromStripeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingStripeSubscriptionStatusFromStripe200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/stripe/subscription-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingStripeSubscriptionStatusFromStripe200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetches subscription status from Stripe and syncs with local database. This endpoint is slow due to external API call. Frontend should cache and poll sparingly (max every 5 minutes). 
     * Get current user\'s Stripe subscription status
     */
    async getBillingStripeSubscriptionStatusFromStripe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingStripeSubscriptionStatusFromStripe200Response> {
        const response = await this.getBillingStripeSubscriptionStatusFromStripeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get subscription by ID
     */
    async getBillingSubscriptionRaw(requestParameters: GetBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionDetailed>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling getBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/subscriptions/{subscriptionId}`.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionDetailedFromJSON(jsonValue));
    }

    /**
     * Get subscription by ID
     */
    async getBillingSubscription(requestParameters: GetBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionDetailed> {
        const response = await this.getBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get subscription by company ID
     */
    async getBillingSubscriptionByCompanyRaw(requestParameters: GetBillingSubscriptionByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionDetailed>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getBillingSubscriptionByCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/subscriptions/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionDetailedFromJSON(jsonValue));
    }

    /**
     * Get subscription by company ID
     */
    async getBillingSubscriptionByCompany(requestParameters: GetBillingSubscriptionByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionDetailed> {
        const response = await this.getBillingSubscriptionByCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tier by code
     */
    async getBillingTierByCodeRaw(requestParameters: GetBillingTierByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tier>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling getBillingTierByCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/billing/tiers/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TierFromJSON(jsonValue));
    }

    /**
     * Get tier by code
     */
    async getBillingTierByCode(requestParameters: GetBillingTierByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tier> {
        const response = await this.getBillingTierByCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all subscription tiers
     */
    async getBillingTiersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Tier>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/billing/tiers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TierFromJSON));
    }

    /**
     * Get all subscription tiers
     */
    async getBillingTiers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Tier>> {
        const response = await this.getBillingTiersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get AI token usage records by company ID
     */
    async getBillingTokenUsageByCompanyRaw(requestParameters: GetBillingTokenUsageByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AiTokenUsage>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getBillingTokenUsageByCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/token-usage/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AiTokenUsageFromJSON));
    }

    /**
     * Get AI token usage records by company ID
     */
    async getBillingTokenUsageByCompany(requestParameters: GetBillingTokenUsageByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AiTokenUsage>> {
        const response = await this.getBillingTokenUsageByCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total AI token usage for company
     */
    async getTotalBillingTokenUsageRaw(requestParameters: GetTotalBillingTokenUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTotalAiTokenUsageResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getTotalBillingTokenUsage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/token-usage/company/{companyId}/total`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTotalAiTokenUsageResponseFromJSON(jsonValue));
    }

    /**
     * Get total AI token usage for company
     */
    async getTotalBillingTokenUsage(requestParameters: GetTotalBillingTokenUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTotalAiTokenUsageResponse> {
        const response = await this.getTotalBillingTokenUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Internal callback endpoint for Stripe events. The request body must be sent exactly as received by Stripe so the `stripe-signature` header can be verified. 
     * Receive Stripe billing webhooks
     */
    async handleStripeWebhookRaw(requestParameters: HandleStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HandleStripeWebhook200Response>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling handleStripeWebhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Stripe-Signature"] = await this.configuration.apiKey("Stripe-Signature"); // stripeWebhookSignatureAuth authentication
        }

        const response = await this.request({
            path: `/api/billing/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HandleStripeWebhook200ResponseFromJSON(jsonValue));
    }

    /**
     * Internal callback endpoint for Stripe events. The request body must be sent exactly as received by Stripe so the `stripe-signature` header can be verified. 
     * Receive Stripe billing webhooks
     */
    async handleStripeWebhook(requestParameters: HandleStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HandleStripeWebhook200Response> {
        const response = await this.handleStripeWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update subscription
     */
    async updateBillingSubscriptionRaw(requestParameters: UpdateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling updateBillingSubscription().'
            );
        }

        if (requestParameters['updateSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSubscriptionRequest',
                'Required parameter "updateSubscriptionRequest" was null or undefined when calling updateBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/billing/subscriptions/{subscriptionId}`.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubscriptionRequestToJSON(requestParameters['updateSubscriptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionFromJSON(jsonValue));
    }

    /**
     * Update subscription
     */
    async updateBillingSubscription(requestParameters: UpdateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription> {
        const response = await this.updateBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetBillingTierByCodeCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type GetBillingTierByCodeCodeEnum = typeof GetBillingTierByCodeCodeEnum[keyof typeof GetBillingTierByCodeCodeEnum];
